module.exports = __webpack_public_path__ + "static/img/24x.7239667.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/24x.jpg
// module id = FX2d
// module chunks = 0